import React from 'react';
import { assest } from '../../Assest/Assest';

function TeethReshaping() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.TeethReshaping} 
        alt="Teeth Reshaping" 
        style={styles.image} 
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Achieve a Perfect Smile with Teeth Reshaping</h2>
        <p style={styles.text}>
          Teeth reshaping, also known as dental contouring, is a quick and effective cosmetic dental procedure that enhances the 
          appearance of your smile. This minimally invasive technique involves removing small amounts of enamel to refine the shape, 
          length, or surface of your teeth for a more harmonious and symmetrical smile.
        </p>
        <p style={styles.text}>
          Teeth reshaping is ideal for correcting uneven edges, minor chips, irregularly shaped teeth, and slight overcrowding. 
          The procedure is painless, requires no anesthesia, and delivers immediate results, giving you a confident, polished smile.
        </p>
        <p style={styles.text}>
          At our clinic, we use advanced tools and a gentle approach to ensure precision and comfort during the procedure. Whether 
          you're preparing for a special occasion or simply want to boost your confidence, teeth reshaping can make a noticeable 
          difference in your smile. Book your consultation today and let us help you achieve your dream smile!
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
};

export default TeethReshaping;
